// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-text-icon[data-v-4e4cfdcc]{display:flex;align-items:top}.link-text-icon .prefix[data-v-4e4cfdcc]{margin:2px 2px 0 0}.link-text-icon .suffix[data-v-4e4cfdcc]{margin:2px 0 0 2px}", ""]);
// Exports
module.exports = exports;
